import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import rootReducers from "./rootReducers";
import api from "./middleware/api";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducers,
  composeEnhancer(applyMiddleware(thunkMiddleware, api))
);



// WEBPACK FOOTER //
// ./src/redux/store.js